

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SwitchComponent extends Vue {
  @Prop({ default: "Switch" }) readonly label!: string;
  @Prop({ default: false }) readonly convert!: boolean;
  @Prop({ default: false }) readonly checked!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly inTable!: boolean;

  private isChecked = false;

  @Watch("checked", { immediate: true })
  checkedChanged(newVal: boolean) {
    this.isChecked = newVal;
  }

  @Watch("isChecked")
  isCheckedChanged(newVal: boolean) {
    this.CheckSwitch();
  }

  public CheckSwitch() {
    if (!this.disabled) {
      this.$emit("update:checked", this.isChecked);
      this.$emit("change", this.isChecked);
    }
  }
}
